// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"MinistryTeamList_listContainer__3QyXu","deleteIcon":"MinistryTeamList_deleteIcon__1zD-E"};